import * as React from 'react';

import { IRatingSection } from '../../types/rating';
import { RatingDetail } from '../RatingDetail';
import * as style from './AggregatedScores.css';

export interface IAggregatedScoresProps {
  sections: IRatingSection[];
}

export const AggregatedScores: React.FC<IAggregatedScoresProps> = props => {
  const { sections } = props;

  return (
    <div data-testid="AggregatedScores" className={style['container']}>
      <ul className={style['list']}>
        {sections.map(({ fillingPercentage, id, name, score }) => (
          <li className={style['item']} key={id}>
            <RatingDetail name={name} fillingPercentage={fillingPercentage} score={score} />
          </li>
        ))}
      </ul>
    </div>
  );
};
